export enum EGameStates {
  LOADING = "LOADING",
  PAUSED = "PAUSED",
  EXPLORE = "EXPLORE",
  REVIEW = "REVIEW",
  PREVIEW = "PREVIEW",
  CONSTRUCTION = "CONSTRUCTION",
  INTERACTION_DISABLED = "INTERACTION_DISABLED",
}
